
'use strict';

define('component!HelpPane',['require','underscore','prop-types','react','translate','lib/react/React.PodioView','lib/RightPaneMediator','mixins/TransitionMixin','mixins/ReflowMixin','lib/GlobalEventBus','lib/Podio.Transport','lib/Podio.Routes','classnames'],function (require) {
  'use strict';

  var _ = require('underscore');
  var PropTypes = require('prop-types');
  var React = require('react');
  var t = require('translate');
  var PodioView = require('lib/react/React.PodioView');
  var rightPane = require('lib/RightPaneMediator');

  var TransitionMixin = require('mixins/TransitionMixin');
  var ReflowMixin = require('mixins/ReflowMixin');

  var globalEvent = require('lib/GlobalEventBus');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  var cx = require('classnames');

  var HelpPane = PodioView.extend({

    mixins: [TransitionMixin, ReflowMixin],

    propTypes: {
      openImmediately: PropTypes.bool,
      promotionId: PropTypes.number
    },

    getDefaultProps: function getDefaultProps() {
      return {
        translations: {
          dismiss: t('Collapse #help_pane')
        },
        isOpen: false
      };
    },

    getInitialState: function getInitialState() {
      return {
        isDismissed: false,
        isOpen: this.props.isOpen
      };
    },

    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen) {
        this.reflow();
        this.open();
      } else {
        this.dismiss();
      }
    },

    componentDidMount: function componentDidMount() {
      this._isMounted = true;
      if (this.props.closeEvent) {
        var closeEvents = _.isArray(this.props.closeEvent) ? this.props.closeEvent : [this.props.closeEvent];

        closeEvents.forEach((function (event) {
          globalEvent.on(event, this.close, this);
        }).bind(this));
      }

      if (this.props.openEvent) {
        globalEvent.on(this.props.openEvent, this.open);
      }

      if (this.props.openImmediately) {
        this.reflow();
        this.open();
      }

      if (_.isDefined(this.props.eventBus)) {
        this.props.eventBus.on('helpPane:dismiss', this.dismiss);
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      this._isMounted = false;
    },

    render: function render() {
      var classSet = {
        'help-pane': true,
        'is-open': this.state.isOpen
      };

      if (this.props.variant) {
        classSet['help-pane--{0}'.format(this.props.variant)] = true;
      }

      var classes = cx(classSet);

      return React.createElement(
        'aside',
        { className: classes, id: 'aside' },
        React.createElement(
          'a',
          { className: 'help-pane__close', onClick: this.dismiss, title: this.props.translations.dismiss },
          this._closeButton()
        ),
        this.props.children
      );
    },

    dismiss: function dismiss() {
      if (_.isDefined(this.props.promotionId) && this._isMounted) {
        this.setState({
          isDismissed: true
        });

        transport.deleteJSON(routes.promotion_path(this.props.promotionId));
      }

      this.close();
    },

    open: function open() {
      if (this.state.isDismissed === false) {
        rightPane.register({
          id: this,
          open: this._handleOpenStateAndEvent.curry(true),
          close: this._handleOpenStateAndEvent.curry(false)
        });
      }
    },

    _handleOpenStateAndEvent: function _handleOpenStateAndEvent(isOpen) {
      this.setState({ isOpen: isOpen }, function () {
        if (_.isDefined(this.props.eventBus)) {
          this.props.eventBus.trigger(isOpen ? 'helpPane:afterOpened' : 'helpPane:afterClosed');
        }
      });
    },

    close: function close() {
      rightPane.unregister({
        id: this
      });
    },

    // Close with X if it's a promotion the get's permanently dismissed, otherwise use the close icon similar to the chat
    _closeButton: function _closeButton() {
      if (_.isDefined(this.props.promotionId)) {
        return React.createElement(
          'span',
          { className: 'help-pane__close-text' },
          '✕'
        );
      } else {
        return React.createElement('span', { className: 'icon-16 help-pane__close-icon' });
      }
    }
  });

  return HelpPane;
});
